import styled from "@emotion/styled";
import { motion } from "framer-motion";
import theme from "../../../theme";

const MainContainer = styled.div`
  background: ${theme.colors.background.main};
  padding: 0px 0px 50px 0px;
  border-top: 0.2px solid ${theme.colors.text.quinary};
  border-image: linear-gradient(
      90deg,
      transparent,
      ${theme.colors.text.quinary} 50%,
      transparent
    )
    0.6;
`;
const Container = styled(motion.div)`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  text-align: center;
`;

const Titlehead = styled(motion.h2)`
  font-size: 40px;
  color: ${theme.colors.text.primary};
  font-family: "Inter", sans-serif;
  margin-bottom: 0px;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const Subtitle = styled(motion.p)`
  font-size: 1rem;
  font-weight: 400; /* regular */
  color: ${theme.colors.text.tertiary};
  font-family: "Inter Regular", "Inter", sans-serif;
  letter-spacing: -0.4px;
  line-height: 26px;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const FeaturesGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 4rem;
`;

const SC = {
  MainContainer,
  Container,
  Titlehead,
  Subtitle,
  FeaturesGrid,
};

export default SC;
